(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.email-signup__form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var container = form.closest('.email-signup-block');
      var successEl = container.querySelector('.email-signup__ajax-success');
      var errorEl = container.querySelector('.email-signup__ajax-error');
      var button = form.querySelector('.email-signup__button');

      // Hide any previous messages
      successEl.style.display = 'none';
      errorEl.style.display = 'none';

      // Disable button during request
      button.disabled = true;

      function sendForm() {
        var freshData = new FormData(form);

        fetch(form.action, {
          method: 'POST',
          body: freshData
        })
        .then(function(response) {
          if (response.ok && response.url && response.url.includes('customer_posted=true')) {
            successEl.style.display = 'flex';
            form.querySelector('input[type="email"]').value = '';
          } else if (response.url && response.url.includes('/challenge')) {
            window.location.href = response.url;
          } else {
            throw new Error('signup_failed');
          }
        })
        .catch(function() {
          errorEl.style.display = 'flex';
        })
        .finally(function() {
          button.disabled = false;
        });
      }

      // Use Shopify's captcha protect if available
      if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) {
        window.Shopify.captcha.protect(form, function() {
          sendForm();
        });
      } else {
        // Captcha not loaded (e.g. theme preview mode) — submit natively
        // and let Shopify handle it on the published theme
        sendForm();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    if (!window.__horizonFacetsPanelInit) {
    window.__horizonFacetsPanelInit = true;

    // ── Panel toggle (FILTER button + Done button) ──
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-panel-target]');
      if (!btn) return;
      if (window.innerWidth < 1025) return; // mobile uses drawer
      e.preventDefault();
      e.stopImmediatePropagation();
      const panel = document.getElementById(btn.dataset.panelTarget);
      if (!panel) return;
      const isOpen = panel.classList.toggle('facets-dropdown-panel--open');
      panel.setAttribute('aria-hidden', String(!isOpen));
      btn.setAttribute('aria-expanded', String(isOpen));
    });

    // ── Price range bucket checkboxes ──
    // Radio-like behavior + hidden input sync.
    // The stock on:change calls updateFilters() which is now a no-op in panel.
    document.addEventListener('change', (e) => {
      const input = e.target.closest('.price-range-buckets__input');
      if (!input) return;
      const container = input.closest('.price-range-buckets');
      const gteHidden = container.querySelector('[data-price-gte]');
      const lteHidden = container.querySelector('[data-price-lte]');
      const allInputs = container.querySelectorAll('.price-range-buckets__input');

      allInputs.forEach((cb) => { if (cb !== input) cb.checked = false; });

      if (input.checked) {
        gteHidden.value = input.dataset.gte;
        lteHidden.value = input.dataset.lte;
      } else {
        gteHidden.value = '';
        lteHidden.value = '';
      }

      // Apply filter immediately
      const facetsForm = input.closest('facets-form-component');
      if (facetsForm && facetsForm.updateFilters) facetsForm.updateFilters();
    });

    // ── Offers toggle ──
    document.addEventListener('change', (e) => {
      const input = e.target.closest('.offers-toggle__input');
      if (!input) return;
      const facetsForm = input.closest('facets-form-component');
      if (facetsForm && facetsForm.updateFilters) facetsForm.updateFilters();
    });
  }

  /* Scroll detection — toggle fade + hint when scrolled to bottom (color swatches + list filters) */
  {
    const initSwatchScroll = () => {
      document.querySelectorAll('.color-swatches-list, .facets__inputs-wrapper--scrollable').forEach((list) => {
        if (list.dataset.scrollInit) return;
        list.dataset.scrollInit = 'true';
        const wrapper = list.closest('.color-swatches-list-wrapper');
        if (!wrapper) return;

        const check = () => {
          const atEnd = list.scrollHeight - list.scrollTop - list.clientHeight < 8;
          wrapper.classList.toggle('is-scrolled-end', atEnd);
        };

        list.addEventListener('scroll', check, { passive: true });
        check();

        /* Click on hint scrolls the list down */
        const hint = wrapper.querySelector('.color-swatches-scroll-hint');
        if (hint) {
          hint.addEventListener('click', () => {
            list.scrollBy({ top: 150, behavior: 'smooth' });
          });
        }
      });
    };

    initSwatchScroll();
    /* Re-init after section re-renders (view transitions, facet updates) */
    document.addEventListener('shopify:section:load', initSwatchScroll);

    /* Observe only the facets containers instead of the entire body */
    const facetsRoot = document.querySelector('.facets-dropdown-panel') || document.querySelector('.facets--drawer');
    if (facetsRoot) {
      new MutationObserver(initSwatchScroll).observe(facetsRoot, { childList: true, subtree: true });
    }
  }
  } catch(e) { console.error(e); }
})();

})();
